module.exports = __webpack_public_path__ + "img/16-1.81f65822.jpg";